import { render, staticRenderFns } from "./TransactionStatusView.vue?vue&type=template&id=2e694c34&scoped=true&"
import script from "./TransactionStatusView.vue?vue&type=script&lang=ts&"
export * from "./TransactionStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e694c34",
  null
  
)

export default component.exports